export enum CCMNotificationModes {
    CLEAR_ON_IMPRESSION = 1,
    CLEAR_ON_ACTION = 2
}
